import { motion } from "framer-motion";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";

const TeamSection = () => {
  const teamMembers = [
    {
      name: "Aamir Khan",
      designation: "Managing Director",
      image: "/images/team/team-1.jpg",
    },
    {
      name: "Rohit Sharma",
      designation: "Project Manager",
      image: "/images/team/team-2.jpg",
    },
    {
      name: "Vikas Patel",
      designation: "Site Engineer",
      image: "/images/team/team-3.jpg",
    },
    {
      name: "Arjun Verma",
      designation: "Property Consultant",
      image: "/images/team/team-4.jpg",
    },
  ];

  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="container-custom">

        {/* Section Header */}

        <div className="text-center max-w-3xl mx-auto mb-16">

          <span className="text-[#F59E0B] uppercase tracking-widest font-semibold">
            Our Team
          </span>

          <h2 className="text-4xl lg:text-5xl font-bold text-[#082B57] mt-4">
            Meet The
            <span className="text-[#F59E0B]"> Experts Behind</span>
            {" "}Our Success
          </h2>

          <p className="text-gray-600 mt-6 leading-8">
            Our experienced professionals bring expertise,
            dedication and innovation to every project we deliver.
          </p>

        </div>

        {/* Team Grid */}

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">

          {teamMembers.map((member, index) => (
            <motion.div
              key={index}
              initial={{
                opacity: 0,
                y: 50,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.5,
                delay: index * 0.1,
              }}
              viewport={{ once: true }}
              className="group bg-white rounded-3xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-2xl transition-all duration-500"
            >

              {/* Image */}

              <div className="relative overflow-hidden">

                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-[350px] object-cover group-hover:scale-110 transition duration-700"
                />

                {/* Social Icons */}

                <div className="absolute inset-0 bg-[#082B57]/70 flex items-center justify-center gap-3 opacity-0 group-hover:opacity-100 transition duration-500">

                  <a
                    href="/"
                    className="w-10 h-10 rounded-full bg-white text-[#082B57] flex items-center justify-center hover:bg-[#F59E0B] hover:text-white transition"
                  >
                    <FaFacebookF />
                  </a>

                  <a
                    href="/"
                    className="w-10 h-10 rounded-full bg-white text-[#082B57] flex items-center justify-center hover:bg-[#F59E0B] hover:text-white transition"
                  >
                    <FaInstagram />
                  </a>

                  <a
                    href="/"
                    className="w-10 h-10 rounded-full bg-white text-[#082B57] flex items-center justify-center hover:bg-[#F59E0B] hover:text-white transition"
                  >
                    <FaLinkedinIn />
                  </a>

                </div>

              </div>

              {/* Content */}

              <div className="p-6 text-center">

                <h3 className="text-2xl font-bold text-[#082B57]">
                  {member.name}
                </h3>

                <p className="text-[#F59E0B] font-medium mt-2">
                  {member.designation}
                </p>

              </div>

            </motion.div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default TeamSection;